import React from "react";

import { cn } from "../../../common/u1/cn";
import { Input } from "../../../common/u1/Input";
import { EditSectionLayout } from "./EditSectionLayout";
import { EditFooterBar } from "./EditFooterBar";
import { SectionStatusPill } from "./SectionStatusPill";
import { SOCIAL_FIELDS } from "./socialFields";
import { useSocialSection } from "./useSocialSection";

/* Section 04 — Social Media. */
const CARD =
  "rounded-[14px] border border-[var(--line)] bg-white px-4 py-5 sm:px-6 sm:py-6";

export const SocialMediaSection = ({
  onNext,
  onPrev,
  onSkip,
  header,
  className = "",
}) => {
  const { values, setField, isLoading, submit, displayStatus } = useSocialSection({
    onSaved: onNext,
  });

  return (
    <EditSectionLayout
      className={className}
      header={header}
      footer={
        <EditFooterBar
          onBack={onPrev}
          onSkip={onSkip}
          onContinue={submit}
          isLoading={isLoading}
        />
      }
    >
      <div className="flex items-center gap-2.5">
        <h2 className="m-0 text-[16px] font-bold text-[var(--ink)] font-sans">
          Social Media
        </h2>
        {/* Not in the design, but the live heading carries an approval glyph
            and dropping it would hide where an edit has got to. */}
        <SectionStatusPill status={displayStatus} />
      </div>

      <div className={cn(CARD, "mt-3.5")}>
        <div className="grid grid-cols-1 gap-x-5 gap-y-4 sm:grid-cols-2">
          {SOCIAL_FIELDS.map((field, index) => (
            <Input
              key={field.key}
              /* Website is the fifth of five, and the design gives it the full
                 width. */
              wrapperClassName={
                index === SOCIAL_FIELDS.length - 1 ? "sm:col-span-2" : undefined
              }
              label={field.label}
              id={`u1-social-${field.key}`}
              type="url"
              value={values[field.key] || ""}
              onChange={(e) => setField(field.key, e.target.value)}
              placeholder={field.placeholder}
            />
          ))}
        </div>
      </div>
    </EditSectionLayout>
  );
};

export default SocialMediaSection;
